<template>
  <v-container fluid class="pa-2">

    <!-- ZAGLAVLJE ------------------------------------------------------------->
    <v-card class="mb-2" outlined>
      <v-card-text class="py-2">

        <v-row dense align="center">
          <v-col cols="12" md="3">
            <span class="subtitle-1 font-weight-bold">eIzvještavanje</span>
            <span class="caption grey--text ml-2">Fiskalizacija 2.0</span>
            <v-chip v-if="postavke && postavke.spremno" x-small class="ml-2"
              :color="postavke.testMode ? 'orange darken-2' : 'red darken-2'" dark>
              {{ postavke.testMode ? 'TESTNI SERVER' : 'PRODUKCIJA' }}
            </v-chip>
            <v-chip v-else-if="postavke" x-small class="ml-2" color="grey" dark>NIJE PODEŠENO</v-chip>
          </v-col>

          <v-col cols="12" md="3">
            <v-btn-toggle v-model="strana" mandatory dense color="primary" @change="ucitaj">
              <v-btn small value="izlaz">Izlazni (IRA)</v-btn>
              <v-btn small value="ulaz">Ulazni (URA)</v-btn>
            </v-btn-toggle>
          </v-col>

          <v-col cols="12" md="3">
            <span class="caption">od</span>
            <input type="date" v-model="fromDate" class="mx-1" />
            <span class="caption">do</span>
            <input type="date" v-model="toDate" class="mx-1" />
            <v-btn x-small color="primary" class="ml-1" :loading="saving" @click="ucitaj">Prikaži</v-btn>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field
              v-model="trazi"
              append-icon="mdi-magnify"
              label="Traži po broju, partneru, OIB-u"
              dense hide-details clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense align="center" class="mt-1">
          <v-col cols="12" md="6">
            <v-checkbox
              v-model="samoNeevidentirani"
              label="samo neevidentirani"
              dense hide-details class="d-inline-block mt-0 mr-4"
            ></v-checkbox>
            <v-checkbox
              v-model="samoNenaplaceni"
              label="samo nenaplaćeni"
              dense hide-details class="d-inline-block mt-0 mr-4"
            ></v-checkbox>
            <v-checkbox
              v-model="samoOdbijeni"
              label="samo odbijeni"
              dense hide-details class="d-inline-block mt-0"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <span class="caption grey--text mr-3">
              {{ redovi.length }} računa · naplaćeno {{ novac(zbroj.naplaceno) }} od {{ novac(zbroj.iznos) }}
            </span>
            <!-- Dugi posao: jedan poziv servisu po racunu, pa se vidi dokle je
                 dosao i moze se prekinuti. -->
            <span v-if="sinkronizacija" class="caption primary--text mr-2">{{ sinkNapredak }}</span>
            <v-btn v-if="sinkronizacija" x-small text color="red darken-2"
              @click="prekiniSinkronizaciju">Prekini</v-btn>
            <v-btn x-small text color="primary" :loading="sinkronizacija"
              :disabled="!spremno" @click="povuciStanje">Povuci stanje</v-btn>
            <v-btn x-small text color="primary" @click="dnevnikOtvoren = true">Dnevnik zahtjeva</v-btn>
          </v-col>
        </v-row>

        <!-- tvrtka nije podesena: reci prije nego korisnik krene slati -->
        <v-row v-if="postavke && !postavke.spremno" dense>
          <v-col cols="12">
            <span class="caption red--text">{{ postavke.razlog }}</span>
          </v-col>
        </v-row>
        <v-row v-if="postavke && postavke.spremno && !postavke.testMode" dense>
          <v-col cols="12">
            <span class="caption red--text text--darken-2">
              Produkcijski server — svaki poslani zahtjev ide stvarno u Poreznu upravu.
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- LISTA RAČUNA ---------------------------------------------------------->
    <v-card outlined>
      <v-data-table
        dense
        :headers="headers"
        :items="redovi"
        :loading="saving"
        item-key="mainLedgerId"
        :items-per-page="50"
        :footer-props="{'items-per-page-options': [25, 50, 100, 200, -1]}"
        no-data-text="Nema računa za odabrane uvjete."
        loading-text="Učitavam..."
        :mobile-breakpoint="0"
        class="eiz-table"
      >
        <template v-slot:[`item.InvoiceDate`]="{ item }">{{ datum(item.InvoiceDate) }}</template>
        <template v-slot:[`item.InvoiceAmount`]="{ item }">{{ novac(item.InvoiceAmount) }}</template>
        <template v-slot:[`item.naplaceno`]="{ item }">
          <span :class="item.naplaceno ? 'green--text text--darken-2' : 'grey--text'">
            {{ novac(item.naplaceno) }}
          </span>
          <span v-if="item.brojNaplata > 1" class="caption grey--text"> ({{ item.brojNaplata }}×)</span>
        </template>
        <template v-slot:[`item.ostatak`]="{ item }">
          <span :class="item.ostatak > 0.005 ? 'red--text' : ''">{{ novac(item.ostatak) }}</span>
        </template>
        <template v-slot:[`item.evidentiran`]="{ item }">
          <v-chip v-if="item.odbijen" x-small color="red darken-2" dark
            title="poslano je odbijanje računa">odbijen</v-chip>
          <template v-else>
            <v-icon v-if="item.evidentiran" small color="green darken-2"
              title="evidentiran">mdi-check-circle</v-icon>
            <v-icon v-else small color="grey lighten-1"
              title="nije evidentiran">mdi-circle-outline</v-icon>
          </template>
          <v-icon v-if="item.zadnjiNeuspjeh" small color="orange darken-2" class="ml-1"
            :title="item.zadnjiNeuspjeh">mdi-alert</v-icon>
        </template>
        <template v-slot:[`item.akcije`]="{ item }">
          <v-btn x-small text color="primary" :disabled="!spremno"
            @click.stop="otvoriNaplatu(item)">naplata</v-btn>
          <v-btn x-small text color="primary" :disabled="!spremno"
            @click.stop="otvoriOdbijanje(item)">odbij</v-btn>
          <v-btn x-small text :disabled="!spremno"
            @click.stop="provjeriNaServisu(item)">provjeri</v-btn>
        </template>

        <template v-slot:[`body.append`]>
          <tr class="font-weight-bold grey lighten-4">
            <td>UKUPNO</td>
            <td>{{ redovi.length }} računa</td>
            <td></td>
            <td></td>
            <td class="text-right">{{ novac(zbroj.iznos) }}</td>
            <td class="text-right">{{ novac(zbroj.naplaceno) }}</td>
            <td class="text-right">{{ novac(zbroj.ostatak) }}</td>
            <td></td>
            <td></td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- NAPLATA --------------------------------------------------------------->
    <v-dialog v-model="naplataOtvorena" max-width="560px">
      <v-card v-if="odabrani">
        <v-card-title class="py-2 subtitle-1">
          Evidencija naplate · račun {{ odabrani.InvoiceNumber }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <!-- podaci o racunu: dvije kolone, oznaka iznad vrijednosti -->
          <v-row dense class="mb-1">
            <v-col cols="12" sm="7">
              <div class="overline grey--text">Partner</div>
              <div class="body-2">{{ odabrani.partnerName }}</div>
              <div class="caption grey--text">OIB {{ odabrani.partnerVATID }}</div>
            </v-col>
            <v-col cols="12" sm="5" class="text-sm-right">
              <div class="overline grey--text">Iznos računa</div>
              <div class="body-2">{{ novac(odabrani.InvoiceAmount) }} €</div>
              <div class="caption grey--text">
                naplaćeno {{ novac(odabrani.naplaceno) }} € · ostatak {{ novac(odabrani.ostatak) }} €
              </div>
            </v-col>
          </v-row>

          <v-divider class="mb-4"></v-divider>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="naplata.paymentDate"
                label="Datum naplate"
                type="date"
                outlined dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="naplata.paidAmount"
                label="Iznos naplate"
                type="number"
                suffix="€"
                outlined dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-select
                v-model="naplata.paymentType"
                :items="tipoviPlacanja"
                label="Tip plaćanja"
                outlined dense
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="naplata.eposlovanjeDocId"
                label="ID dokumenta u ePoslovanju (neobavezno)"
                outlined dense
                persistent-hint
                hint="Ako je poznat, zahtjev ide preciznije; inače se šalje po broju računa i OIB-ima"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-alert dense text type="info" class="caption mb-0 mt-4">
            Negativan iznos je storno ranije poslane naplate.
            Za parcijalne uplate šaljite više zahtjeva, jedan po uplati.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>
          <v-btn text @click="naplataOtvorena = false">Odustani</v-btn>
          <v-btn color="primary" depressed :loading="slanje" @click="posaljiNaplatu">Pošalji</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ODBIJANJE ------------------------------------------------------------->
    <v-dialog v-model="odbijanjeOtvoreno" max-width="560px">
      <v-card v-if="odabrani">
        <v-card-title class="py-2 subtitle-1">
          Evidencija odbijanja · račun {{ odabrani.InvoiceNumber }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-row dense class="mb-1">
            <v-col cols="12" sm="7">
              <div class="overline grey--text">Partner</div>
              <div class="body-2">{{ odabrani.partnerName }}</div>
              <div class="caption grey--text">OIB {{ odabrani.partnerVATID }}</div>
            </v-col>
            <v-col cols="12" sm="5" class="text-sm-right">
              <div class="overline grey--text">Iznos računa</div>
              <div class="body-2">{{ novac(odabrani.InvoiceAmount) }} €</div>
              <div class="caption grey--text">{{ datum(odabrani.InvoiceDate) }}</div>
            </v-col>
          </v-row>

          <v-divider class="mb-4"></v-divider>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="odbijanje.rejectionDate"
                label="Datum odbijanja"
                type="date"
                outlined dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- vlastiti red: nazivi tipova su predugi za pola sirine i reze se -->
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="odbijanje.rejectionType"
                :items="tipoviOdbijanja"
                label="Tip odbijanja"
                outlined dense
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="odbijanje.rejectionReason"
                label="Razlog odbijanja"
                rows="3"
                outlined dense
                counter="200"
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-alert dense text type="info" class="caption mb-0 mt-4">
            Odbijanje šalje kupac, i to za račun koji je prethodno fiskaliziran kao ulazni.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>
          <v-btn text @click="odbijanjeOtvoreno = false">Odustani</v-btn>
          <v-btn color="primary" depressed :loading="slanje" @click="posaljiOdbijanje">Pošalji</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- STANJE NA SERVISU ----------------------------------------------------->
    <v-dialog v-model="servisOtvoren" max-width="900px" scrollable>
      <v-card>
        <v-card-title class="py-2 subtitle-1">
          Zahtjevi na servisu · račun {{ odabrani ? odabrani.InvoiceNumber : '' }}
          <v-spacer></v-spacer>
          <v-btn icon @click="servisOtvoren = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-2" style="max-height: 60vh;">
          <v-progress-linear v-if="slanje" indeterminate color="primary"></v-progress-linear>
          <v-data-table dense :headers="servisHeaders" :items="servisRedovi"
            :items-per-page="-1" hide-default-footer
            no-data-text="Servis nema zabilježenih zahtjeva za ovaj račun.">
            <template v-slot:[`item.type`]="{ item }">{{ tipNaziv(item.type) }}</template>
            <template v-slot:[`item.success`]="{ item }">
              <v-icon v-if="item.success" small color="green darken-2">mdi-check</v-icon>
              <v-icon v-else small color="red darken-2">mdi-close</v-icon>
            </template>
            <template v-slot:[`item.createdOn`]="{ item }">{{ datumVrijeme(item.createdOn) }}</template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DNEVNIK --------------------------------------------------------------->
    <v-dialog v-model="dnevnikOtvoren" max-width="1200px" scrollable>
      <v-card>
        <v-card-title class="py-2 subtitle-1">
          Dnevnik poslanih zahtjeva
          <v-spacer></v-spacer>
          <v-checkbox v-model="samoGreske" label="samo greške" dense hide-details
            class="mt-0 mr-3" @change="ucitajDnevnik"></v-checkbox>
          <v-btn icon @click="dnevnikOtvoren = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-2" style="max-height: 65vh;">
          <v-data-table dense :headers="dnevnikHeaders" :items="dnevnik"
            :items-per-page="100" no-data-text="Nema poslanih zahtjeva.">
            <template v-slot:[`item.sentAt`]="{ item }">{{ datumVrijeme(item.sentAt) }}</template>
            <template v-slot:[`item.requestType`]="{ item }">{{ tipNaziv(item.requestType) }}</template>
            <template v-slot:[`item.paidAmount`]="{ item }">
              <span v-if="item.paidAmount !== null">{{ novac(item.paidAmount) }}</span>
            </template>
            <template v-slot:[`item.success`]="{ item }">
              <v-icon v-if="item.success" small color="green darken-2">mdi-check</v-icon>
              <v-icon v-else small color="red darken-2">mdi-close</v-icon>
            </template>
            <template v-slot:[`item.testMode`]="{ item }">
              <span class="caption">{{ item.testMode ? 'test' : 'prod' }}</span>
            </template>
            <template v-slot:[`item.izvor`]="{ item }">
              <span class="caption" :class="item.izvor === 'servis' ? 'blue--text' : 'grey--text'">
                {{ item.izvor === 'servis' ? 'servis' : 'mi' }}
              </span>
            </template>
            <template v-slot:[`item.greska`]="{ item }">
              <span class="caption red--text">{{ item.errorDescription || item.errorCode || '' }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" bottom :timeout="timeout" :color="color">{{ text }}</v-snackbar>
  </v-container>
</template>

<script>
// eIzvjestavanje - Fiskalizacija 2.0 preko ePoslovanje API v2.
//
// Racuni se citaju iz knjige (MainLedgers): IRA za izlaznu stranu, URA za
// ulaznu. Stanje eIzvjestavanja za svaki racun slaze server iz dnevnika, jer
// jedan racun moze imati vise zahtjeva - parcijalne uplate idu jedna po jedna,
// a storno kao negativan iznos.
//
// API kljuc se ne dira ovdje; server ga cita iz postavki tvrtke.

import EIzvjestavanjeService from '@/services/EIzvjestavanjeService'
import dayjs from 'dayjs'

const num = (v) => {
  const n = parseFloat(v)
  return isNaN(n) ? 0 : n
}

const fold = (v) => String(v === null || v === undefined ? '' : v)
  .toLowerCase()
  .replace(/[čć]/g, 'c').replace(/ž/g, 'z').replace(/š/g, 's').replace(/đ/g, 'd')

const TIPOVI = {
  1: 'Evidencija izlaznog računa',
  2: 'Evidencija ulaznog računa',
  3: 'Isporuka bez eRačuna',
  4: 'Naplata',
  5: 'Odbijanje'
}

// Koliko racuna ide u jednoj seriji "Povuci stanje". Servis trazi jedan poziv
// po racunu, pa veca serija znaci duzi zahtjev i vecu sansu da padne veza.
const SERIJA = 200

export default {
  name: 'eizvjestavanje',
  data () {
    return {
      saving: false,
      slanje: false,
      sinkronizacija: false,
      sinkNapredak: '',
      sinkPrekid: false,
      snackbar: false,
      text: '',
      color: 'red',
      timeout: 6000,

      strana: 'izlaz',
      fromDate: null,
      toDate: null,
      trazi: '',
      samoNeevidentirani: false,
      samoNenaplaceni: false,
      samoOdbijeni: false,

      stavke: [],
      postavke: null,

      odabrani: null,
      naplataOtvorena: false,
      odbijanjeOtvoreno: false,
      servisOtvoren: false,
      dnevnikOtvoren: false,
      samoGreske: false,

      naplata: {paymentDate: null, paidAmount: null, paymentType: 1, eposlovanjeDocId: ''},
      odbijanje: {rejectionDate: null, rejectionType: 1, rejectionReason: ''},

      servisRedovi: [],
      dnevnik: [],

      // vrijednosti su one iz specifikacije, ne izmisljene
      tipoviPlacanja: [
        {text: '1 - Transakcijski račun', value: 1},
        {text: '2 - Obračunsko plaćanje', value: 2},
        {text: '3 - Ostalo', value: 3}
      ],
      tipoviOdbijanja: [
        {text: '1 - Neusklađenost bez utjecaja na porez', value: 1},
        {text: '2 - Neusklađenost s utjecajem na porez', value: 2},
        {text: '3 - Ostalo', value: 3}
      ]
    }
  },
  mounted () {
    const g = this.businessYear
    this.fromDate = g + '-01-01'
    this.toDate = g + '-12-31'
    this.ucitajPostavke()
    this.ucitaj()
  },
  computed: {
    companyid () { return this.$store.state.companyid },
    businessYear () { return this.$store.state.businessYear },
    spremno () { return !!(this.postavke && this.postavke.spremno) },
    trazilica () {
      return fold(this.trazi).split(/\s+/).filter(t => t.length > 0)
    },
    // Filtri idu ovdje, a ne u v-data-table, da zbrojevi ispod tablice uvijek
    // odgovaraju onome sto se vidi.
    redovi () {
      let r = this.stavke
      if (this.samoNeevidentirani) { r = r.filter(x => !x.evidentiran) }
      if (this.samoNenaplaceni) { r = r.filter(x => num(x.ostatak) > 0.005) }
      if (this.samoOdbijeni) { r = r.filter(x => x.odbijen) }
      const t = this.trazilica
      if (t.length) {
        r = r.filter(x => {
          const hay = fold([x.InvoiceNumber, x.partnerName, x.partnerVATID,
            x.BookName, x.InvoiceAmount, x.naplaceno].join(' '))
          return t.every(w => hay.indexOf(w) !== -1)
        })
      }
      return r
    },
    zbroj () {
      const t = {iznos: 0, naplaceno: 0, ostatak: 0}
      this.redovi.forEach(x => {
        t.iznos += num(x.InvoiceAmount)
        t.naplaceno += num(x.naplaceno)
        t.ostatak += num(x.ostatak)
      })
      Object.keys(t).forEach(k => { t[k] = Math.round(t[k] * 100) / 100 })
      return t
    },
    headers () {
      return [
        {text: 'Broj', value: 'InvoiceNumber', width: '110px'},
        {text: 'Partner', value: 'partnerName', width: '230px'},
        {text: 'OIB', value: 'partnerVATID', width: '110px'},
        {text: 'Datum', value: 'InvoiceDate', width: '105px'},
        {text: 'Iznos', value: 'InvoiceAmount', align: 'end', width: '110px'},
        {text: 'Naplaćeno', value: 'naplaceno', align: 'end', width: '120px'},
        {text: 'Ostatak', value: 'ostatak', align: 'end', width: '110px'},
        {text: 'Stanje', value: 'evidentiran', align: 'center', width: '90px', sortable: false},
        {text: '', value: 'akcije', width: '215px', sortable: false}
      ]
    },
    servisHeaders () {
      return [
        {text: 'Vrsta', value: 'type', width: '190px'},
        {text: 'Poslano', value: 'createdOn', width: '150px'},
        {text: 'OK', value: 'success', align: 'center', width: '60px'},
        {text: 'Referenca', value: 'referenceId', width: '200px'},
        {text: 'Greška', value: 'errorDescription'}
      ]
    },
    dnevnikHeaders () {
      return [
        {text: 'Poslano', value: 'sentAt', width: '150px'},
        {text: 'Vrsta', value: 'requestType', width: '180px'},
        {text: 'Račun', value: 'InvoiceNumber', width: '100px'},
        {text: 'Partner', value: 'partnerName'},
        {text: 'Iznos', value: 'paidAmount', align: 'end', width: '100px'},
        {text: 'OK', value: 'success', align: 'center', width: '60px'},
        {text: 'Srv', value: 'testMode', align: 'center', width: '60px'},
        {text: 'Izvor', value: 'izvor', align: 'center', width: '70px'},
        {text: 'Greška', value: 'greska'}
      ]
    }
  },
  methods: {
    novac (v) {
      return num(v).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    datum (d) { return d ? dayjs(d).format('DD.MM.YYYY') : '' },
    datumVrijeme (d) { return d ? dayjs(d).format('DD.MM.YYYY HH:mm') : '' },
    tipNaziv (t) { return TIPOVI[parseInt(t, 10)] || ('tip ' + t) },
    javi (msg, col) {
      this.text = msg
      this.color = col || 'red'
      this.snackbar = true
    },

    async ucitajPostavke () {
      try {
        const {data} = await EIzvjestavanjeService.postavke({CompanyId: this.companyid})
        this.postavke = data
      } catch (err) {
        this.postavke = {spremno: false, razlog: 'Ne mogu dohvatiti postavke tvrtke.'}
      }
    },

    async ucitaj () {
      if (!this.companyid) {
        this.javi('Nije odabrana tvrtka.')
        return
      }
      this.saving = true
      try {
        const {data} = await EIzvjestavanjeService.racuni({
          CompanyId: this.companyid,
          BusinessYear: this.businessYear,
          strana: this.strana,
          fromDate: this.fromDate,
          toDate: this.toDate
        })
        this.stavke = data && data.racuni ? data.racuni : []
        if (!this.stavke.length) { this.javi('Nema računa za odabrane uvjete.', 'orange darken-2') }
      } catch (err) {
        this.stavke = []
        this.javi('Greška pri dohvatu: ' + this.poruka(err))
      }
      this.saving = false
    },

    poruka (err) {
      const d = err && err.response && err.response.data
      if (d && d.errors) { return d.errors.join(' ') }
      return err && err.message ? err.message : String(err)
    },

    otvoriNaplatu (item) {
      this.odabrani = item
      this.naplata = {
        paymentDate: dayjs().format('YYYY-MM-DD'),
        // ponudi ostatak, ne cijeli iznos - parcijalne uplate su pravilo
        paidAmount: num(item.ostatak) > 0 ? num(item.ostatak) : num(item.InvoiceAmount),
        paymentType: 1,
        eposlovanjeDocId: ''
      }
      this.naplataOtvorena = true
    },

    otvoriOdbijanje (item) {
      this.odabrani = item
      this.odbijanje = {
        rejectionDate: dayjs().format('YYYY-MM-DD'),
        rejectionType: 1,
        rejectionReason: ''
      }
      this.odbijanjeOtvoreno = true
    },

    async posalji (body, uspjeh) {
      // Na produkciji zahtjev stvarno ide Poreznoj upravi i ne moze se povuci
      // (storno naplate je novi zahtjev s negativnim iznosom). Zato pitanje.
      if (this.postavke && this.postavke.spremno && !this.postavke.testMode) {
        const sto = body.requestType === 5 ? 'odbijanje' : 'naplatu'
        if (!window.confirm(
          'PRODUKCIJA — zahtjev ide stvarno u Poreznu upravu.\n\n' +
          'Račun: ' + (this.odabrani ? this.odabrani.InvoiceNumber : '') + '\n' +
          'Šaljem ' + sto + '. Nastaviti?')) {
          return false
        }
      }
      this.slanje = true
      try {
        const {data} = await EIzvjestavanjeService.posalji(body)
        if (data && data.ok) {
          this.javi(uspjeh + (data.testMode ? ' (testni server)' : ''), 'green darken-2')
          await this.ucitaj()
          return true
        }
        this.javi((data && data.errors ? data.errors.join(' — ') : 'Zahtjev nije prošao.'))
        await this.ucitaj()
        return false
      } catch (err) {
        this.javi('Greška: ' + this.poruka(err))
        return false
      } finally {
        this.slanje = false
      }
    },

    async posaljiNaplatu () {
      const ok = await this.posalji({
        CompanyId: this.companyid,
        BusinessYear: this.businessYear,
        mainLedgerId: this.odabrani.mainLedgerId,
        requestType: 4,
        paymentDate: this.naplata.paymentDate,
        paidAmount: num(this.naplata.paidAmount),
        paymentType: this.naplata.paymentType,
        eposlovanjeDocId: this.naplata.eposlovanjeDocId || undefined,
        email: this.$store.state.user ? this.$store.state.user.email : null
      }, 'Naplata evidentirana.')
      if (ok) { this.naplataOtvorena = false }
    },

    async posaljiOdbijanje () {
      const ok = await this.posalji({
        CompanyId: this.companyid,
        BusinessYear: this.businessYear,
        mainLedgerId: this.odabrani.mainLedgerId,
        requestType: 5,
        rejectionDate: this.odbijanje.rejectionDate,
        rejectionType: this.odbijanje.rejectionType,
        rejectionReason: this.odbijanje.rejectionReason,
        email: this.$store.state.user ? this.$store.state.user.email : null
      }, 'Odbijanje evidentirano.')
      if (ok) { this.odbijanjeOtvoreno = false }
    },

    // sto servis Porezne uprave zna o racunu - neovisno o nasem dnevniku
    async provjeriNaServisu (item) {
      this.odabrani = item
      this.servisRedovi = []
      this.servisOtvoren = true
      this.slanje = true
      try {
        const {data} = await EIzvjestavanjeService.zahtjevi({
          CompanyId: this.companyid,
          documentId: item.InvoiceNumber,
          issueYear: item.InvoiceDate ? item.InvoiceDate.substr(0, 4) : this.businessYear,
          supplierPartyVATId: this.strana === 'izlaz' ? (this.postavke ? this.postavke.oib : '') : item.partnerVATID,
          customerPartyVATId: this.strana === 'izlaz' ? item.partnerVATID : (this.postavke ? this.postavke.oib : '')
        })
        if (data && data.ok) {
          this.servisRedovi = data.requests || []
          if (!this.servisRedovi.length) { this.javi('Servis nema zahtjeva za ovaj račun.', 'orange darken-2') }
        } else {
          this.javi(data && data.errors ? data.errors.join(' — ') : 'Greška pri dohvatu.')
        }
      } catch (err) {
        this.javi('Greška: ' + this.poruka(err))
      }
      this.slanje = false
    },

    // Povlaci stanje sa servisa za sve racune razdoblja. Lista inace zna samo
    // ono sto je poslao ovaj sustav - odbijanje izlaznog racuna salje kupac,
    // izvan naseg sustava, pa se bez ovoga nikad ne bi vidjelo.
    //
    // Servis trazi jedan poziv po racunu i nema skupni dohvat. U godini ima
    // firmi s preko 2.000 racuna, pa jedan zahtjev ne moze obuhvatiti sve -
    // ide u serijama po SERIJA racuna dok ih ima, s prikazom napretka i
    // mogucnoscu prekida.
    async povuciStanje () {
      if (!this.spremno || this.sinkronizacija) { return }
      this.sinkronizacija = true
      this.sinkPrekid = false
      this.sinkNapredak = 'pokrećem…'

      const zbir = {provjereno: 0, dodano: 0, preskoceno: 0}
      const greske = []
      let offset = 0
      let ukupno = null
      let imaJos = true
      let pukloJe = false

      try {
        while (imaJos && !this.sinkPrekid) {
          const {data} = await EIzvjestavanjeService.sinkroniziraj({
            CompanyId: this.companyid,
            BusinessYear: this.businessYear,
            strana: this.strana,
            fromDate: this.fromDate,
            toDate: this.toDate,
            limit: SERIJA,
            offset
          })

          if (!data || !data.ok) {
            this.javi(data && data.errors ? data.errors.join(' — ') : 'Sinkronizacija nije uspjela.')
            pukloJe = true
            break
          }

          zbir.provjereno += data.provjereno || 0
          zbir.dodano += data.dodano || 0
          zbir.preskoceno += data.preskoceno || 0
          if (data.greske && data.greske.length) { greske.push(...data.greske) }

          ukupno = data.ukupno !== undefined ? data.ukupno : null
          imaJos = data.imaJos === true
          // Ako serija nije vratila ni jedan racun, dalje nema sto - inace bi
          // se vrtjelo u krug na istom offsetu.
          if (!data.ukupnoRacuna) { imaJos = false }
          offset = data.obradenoDo !== undefined ? data.obradenoDo : offset + SERIJA

          this.sinkNapredak = ukupno
            ? Math.min(offset, ukupno) + ' / ' + ukupno + ' računa'
            : offset + ' računa'
        }

        if (!pukloJe) {
          const dijelovi = ['provjereno ' + zbir.provjereno + ' računa',
            'novih zapisa ' + zbir.dodano]
          if (zbir.preskoceno) { dijelovi.push('preskočeno ' + zbir.preskoceno) }
          if (this.sinkPrekid && imaJos) { dijelovi.push('prekinuto na vaš zahtjev') }
          this.javi(dijelovi.join(' · '), zbir.dodano ? 'green darken-2' : 'blue-grey')
        }
        if (greske.length) {
          // eslint-disable-next-line
          console.log('sinkronizacija, greške po računima:', greske)
        }
        await this.ucitaj()
      } catch (err) {
        this.javi('Greška pri sinkronizaciji: ' + this.poruka(err))
      }

      this.sinkronizacija = false
      this.sinkNapredak = ''
    },

    prekiniSinkronizaciju () {
      this.sinkPrekid = true
      this.sinkNapredak = 'prekidam nakon ove serije…'
    },

    async ucitajDnevnik () {
      try {
        const {data} = await EIzvjestavanjeService.index({
          CompanyId: this.companyid,
          BusinessYear: this.businessYear,
          samoGreske: this.samoGreske ? 'true' : 'false'
        })
        this.dnevnik = data && data.zapisi ? data.zapisi : []
      } catch (err) {
        this.dnevnik = []
        this.javi('Greška pri dohvatu dnevnika: ' + this.poruka(err))
      }
    }
  },
  watch: {
    dnevnikOtvoren (v) {
      if (v) { this.ucitajDnevnik() }
    }
  }
}
</script>

<style scoped>
/* isto kao stanje skladista: tijelo 15px, zaglavlje 13px.
   !important jer je Vuetifyjev selektor specificniji od scoped klase. */
.eiz-table >>> tbody td {
  font-size: 15px !important;
}
.eiz-table >>> thead th {
  font-size: 13px !important;
}
/* Redak je bio 69px jer su se naziv partnera i gumbi lomili u vise redova.
   Sirina stupca Partner to rjesava, a nowrap sprjecava da se vrati na uzem
   prozoru. Vodoravni razmak s 16px na 10px. */
.eiz-table >>> tbody td,
.eiz-table >>> thead th {
  white-space: nowrap;
  padding: 0 10px !important;
}
.eiz-table >>> tbody td {
  height: 34px !important;
}
input[type="date"] {
  border: 1px solid #bdbdbd;
  border-radius: 3px;
  padding: 1px 4px;
  font-size: 13px;
}
</style>
